import { useAppState } from 'oasis-os-react';
/**
 * Fetch value of a field retrieved from Contentful.
 * If cms data is passed, it will be used to find the desired field.
 * Otherwise, the root-level data obtained from the CMS at the
 * Feature App's initialization will be taken from the App state.
 *
 * The Generic type FieldType is referred to the field type you are looking to retrieve.
 * The Generic type DataSetType is for cumulative dataset that includes all fields.
 *
 * @param fieldName Contentful model's field name
 * @param cmsData Entry or EntryCollection optional data used to get the field
 */
function useField(fieldName, cmsData) {
    const [appState] = useAppState();
    const entryOrCollection = cmsData || appState;
    if (!entryOrCollection || Object.keys(entryOrCollection).length === 0) {
        // Gracefully exit right away
        return undefined;
    }
    if (entryOrCollection.hasOwnProperty('fields')) {
        const entry = entryOrCollection;
        if (fieldName) {
            return entry.fields[fieldName];
        }
        else {
            // if fieldname is undefined, then return all fields
            return entry.fields;
        }
    }
    else {
        // We seem to be working with a Collection of Entries
        // It's expected that this was a search for a route so we'll assume the first array item
        const items = entryOrCollection.items;
        return items?.[0]?.fields?.[fieldName];
    }
}
export default useField;
